import React from "react";
import FormCard from "../FormComponents/FormCard";
import Icon from "../Icons/Icon";
import { SCHEDULE_DATA } from "../../constants/scheduleData";

/**
 * Step 1: Show Deadlines & Schedule
 *
 * This step displays the schedule and deadlines for the show.
 * Data can be fetched from API using the useContractData hook.
 */
const Step1 = ({ scheduleData = SCHEDULE_DATA }) => {
  return (
    <div className="form-page">
      <div className="form-page-header">
        <h2 className="form-page-title">Show Deadlines & Schedule</h2>
        <p className="form-page-subtitle">
          Arett Sales Open House — Atlantic City Convention Center
        </p>
      </div>

      <FormCard
        title="Show Schedule Planning & Training Deadlines"
        icon={<Icon name="calendar" size={14} />}
      >
        {scheduleData.map((section, si) => (
          <div key={si} className="schedule-section">
            <div className="schedule-section-title">{section.section}</div>
            <table className="schedule-table">
              <tbody>
                {section.rows.map((row, ri) => (
                  <tr key={ri}>
                    <td style={{ whiteSpace: "pre-line" }}>{row.date}</td>
                    <td style={{ whiteSpace: "pre-line" }}>{row.desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </FormCard>

      <div className="form-footer-note">
        <strong>PLEASE PRINT THIS OUT FOR YOUR RECORDS</strong>
        <br />
        Please refer to vendor portal for any and all updates. Email updates
        will also be sent so be sure to whitelist all @arett.com domains
      </div>
    </div>
  );
};

export default Step1;
